export enum CalendarViewType {
  Day = '0',
  Week = '1',
  Month = '2',
  Timeline = '3',
  WorkWeek = '4'
}